import {legacy_createStore as createStore, applyMiddleware} from "redux"
import rootReducer from "./rootReducer"
import {persistStore} from "redux-persist"
import {composeWithDevTools} from "redux-devtools-extension"
import thunk from "redux-thunk"

const store = createStore(rootReducer, applyMiddleware(thunk))
export const persistor = persistStore(store)
export default store
